<template>
    <v-select v-model="time" :menu-props="{offsetY: true}" :color="color" :items="selectItems" :dense="dense" :readonly="readonly" :disabled="disabled" :outlined="outlined" :filled="filled" :label="label" :placeholder="placeholder" :prepend-inner-icon="!hideIcon ? 'mdi-clock' : ''" hide-details></v-select>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    data(){
        return {
            time: '',
        }
    },
    props: {
        label: {},
        value: {},
        color: {type: String, default: 'primary'},
        hideIcon: {type: Boolean, default: false},
        outlined: {type: Boolean, default: false},
        filled: {type: Boolean, default: false},
        dense: {type: Boolean, default: false},
        disabled: {type: Boolean, default: false},
        readonly: {type: Boolean, default: false},
        min: {},
        max: {},
        placeholder: {},
        replaces: Array,
    },
    computed: {
        selectItems(){
            let items = [];
            for (let h=0; h<24; h++){
                if (h < 10){
                    h = '0' + h
                }
                ['00', '15', '30', '45'].forEach(m=>{
                    let time = `${h}:${m}`;
                    if (this.min && time === this.min){
                        items = [];
                    }else{
                        items.push({text: this.timeReadable(time), value: time});
                    }
                })
            }
            
            items = items.filter(item=>{
                return item.value !== '00:00';
            })
            items.push({text: this.timeReadable(`23:59`), value: `23:59`});

            if (!this.min){
                items.push(...items.slice(0, 23));
                items = items.slice(23);
            }

            return items;
        },
        ...GlobalComputed
    },
    watch: {
        time(time, old){
            if (time === ':00'){
                this.time = old;
            }else{
                if (time){
                    if (this.replaces && this.replaces.length){
                        this.applyReplaces(time);
                    }
                }

                if (time !== this.value){
                    this.$emit('input', time); // close
                }
            }
        },
        value(time){
            if (time !== this.time){
                this.time = time;
            }
        }
    },
    methods: {
        timeReadable(time){
            const timeArr = time.split(':');
            if (!time){
                return '';
            }
            
            if (timeArr[0] < 12){
                const hours = parseInt(timeArr[0]) === 0 ? '12' : timeArr[0];
                return `${hours}:${timeArr[1]} AM`;
            }else{
                let hours = parseInt(timeArr[0]) - 12;
                if (hours === 0){
                    hours = 12;
                }
                const hoursValue = hours < 10 ? '0' + hours : hours;
                return `${hoursValue}:${timeArr[1]} PM`
            }
        },
        applyReplaces(time){
            const replaces = this.replaces;
            if (time){
                replaces.forEach(replace=>{
                    if (time === replace[0]){
                        this.time = replace[1];
                    }
                })
            }
        },
        ...GlobalMethods
    },
    mounted(){
        if (this.value){
            this.time = this.value;
        }
    }
};
</script>

<style lang="scss" scoped>

</style>